import { render, staticRenderFns } from "./PickUpSearchPop.vue?vue&type=template&id=3be56f62&scoped=true"
import script from "./PickUpSearchPop.vue?vue&type=script&lang=js"
export * from "./PickUpSearchPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be56f62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3be56f62')) {
      api.createRecord('3be56f62', component.options)
    } else {
      api.reload('3be56f62', component.options)
    }
    module.hot.accept("./PickUpSearchPop.vue?vue&type=template&id=3be56f62&scoped=true", function () {
      api.rerender('3be56f62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/PickUpSearchPop.vue"
export default component.exports